import { useTranslation } from 'react-i18next'
import { orderDefectMarks } from '../utils/defectMarks'

export type ListingDefectMark = {
  x: number
  y: number
  label: string
  photo_index?: number
}

type Props = {
  marks: ListingDefectMark[]
  photoCount: number
  activePhoto: number
  onSelectPhoto: (index: number) => void
  className?: string
}

export default function ListingDefectsSummary({
  marks,
  activePhoto,
  onSelectPhoto,
  className,
}: Props) {
  const { t } = useTranslation()
  if (!marks.length) return null

  return (
    <section
      className={`listing-detail-defects-summary${className ? ` ${className}` : ''}`}
      aria-label={t('listing.detailDefects', { count: marks.length })}
    >
      <h3 className="listing-detail-defects-summary__title">
        {t('listing.detailDefects', { count: marks.length })}
      </h3>
      <ul className="listing-detail-defects-summary__list">
        {orderDefectMarks(marks).map((mark, i) => {
          const photoIdx = mark.photo_index ?? 0
          return (
            <li key={`${mark.x}-${mark.y}-${photoIdx}-${i}`}>
              <button
                type="button"
                className={`listing-detail-defects-summary__item${
                  photoIdx === activePhoto ? ' listing-detail-defects-summary__item--active' : ''
                }`}
                onClick={() => onSelectPhoto(photoIdx)}
              >
                <span className="listing-detail-defects-summary__pin" aria-hidden="true">
                  {i + 1}
                </span>
                <span className="listing-detail-defects-summary__label">{mark.label}</span>
              </button>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
